import { InputBase } from './input-base'

export class FormSection {
  key: string

  inputs: InputBase<string>[]

  label: string

  constructor(
    key: string,
    inputs: InputBase<string>[],
    options: {
      label?: string
    } = {},
  ) {
    this.key = key
    this.inputs = inputs
    this.label = options.label || ''
  }
}
